var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs, _path17, _path18, _path19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoloToken(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1054.1 1037.2",
    style: {
      enableBackground: "new 0 0 1054.1 1037.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:url(#SVGID_4_);}\n\t.st4{fill:url(#SVGID_5_);}\n\t.st5{fill:url(#SVGID_6_);}\n\t.st6{fill:url(#SVGID_7_);}\n\t.st7{fill:url(#SVGID_8_);}\n\t.st8{fill:url(#SVGID_9_);}\n\t.st9{fill:#FFFAE6;}\n\t.st10{fill:url(#SVGID_10_);}\n\t.st11{fill:url(#SVGID_11_);}\n\t.st12{fill:url(#SVGID_12_);}\n\t.st13{fill:url(#SVGID_13_);}\n\t.st14{clip-path:url(#SVGID_15_);}\n\t.st15{fill:url(#SVGID_16_);}\n\t.st16{fill:url(#SVGID_17_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 501.1677,
    cy: -348.657,
    r: 527.0175,
    gradientTransform: "matrix(1 0 0 -0.9901 0 153.7016)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1152DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3227,
    style: {
      stopColor: "#1152DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6649,
    style: {
      stopColor: "#1050D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1050D8"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1031.7,516.2c0,276.7-226.5,501-506,501s-506-224.3-506-501s226.5-501,506-501S1031.7,239.5,1031.7,516.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 525.7378,
    y1: -264.4817,
    x2: 525.7378,
    y2: -1159.7722,
    gradientTransform: "matrix(1 0 0 -1 0 172.5544)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3759A0",
      stopOpacity: 0.04
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4671,
    style: {
      stopColor: "#0E45BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8016,
    style: {
      stopColor: "#305194"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C63B5"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.7,516.2c0,178.8,94.6,335.7,237,424.4h538c142.4-88.7,237-245.6,237-424.4s-94.6-335.7-237-424.4h-538 C114.4,180.5,19.7,337.4,19.7,516.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 525.7378,
    y1: -464.8779,
    x2: 525.7378,
    y2: 439.8502,
    gradientTransform: "matrix(1 0 0 -1 0 172.5544)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3759A0",
      stopOpacity: 0.04
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4671,
    style: {
      stopColor: "#0E45BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8016,
    style: {
      stopColor: "#305194"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C63B5"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M19.7,516.2c0,127.6,48.2,244,127.5,332.4h757.1c79.3-88.5,127.5-204.9,127.5-332.4s-48.2-244-127.5-332.4 H147.2C67.9,272.2,19.7,388.6,19.7,516.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 525.7378,
    y1: -358.7856,
    x2: 525.7378,
    y2: -648.1317,
    gradientTransform: "matrix(1 0 0 -1 0 172.5544)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3759A0",
      stopOpacity: 0.04
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4671,
    style: {
      stopColor: "#0E45BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8016,
    style: {
      stopColor: "#305194"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C63B5"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M19.7,516.2c0,74.6,16.5,145.3,46,208.9h920.1c29.5-63.6,46-134.3,46-208.9s-16.5-145.3-46-208.9H65.7 C36.2,370.9,19.7,441.6,19.7,516.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 525.7378,
    y1: -453.0897,
    x2: 525.7378,
    y2: 39.6229,
    gradientTransform: "matrix(1 0 0 -1 0 172.5544)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3759A0",
      stopOpacity: 0.04
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4671,
    style: {
      stopColor: "#0E45BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8016,
    style: {
      stopColor: "#305194"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C63B5"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M19.7,516.2c0,43.2,5.5,85,15.9,125h980.2c10.4-40,15.9-81.8,15.9-125c0-43.2-5.5-85-15.9-125H35.6 C25.3,431.2,19.7,473,19.7,516.2z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_6_",
    cx: 337.47,
    cy: -229.6043,
    r: 708.3687,
    gradientTransform: "matrix(1 0 0 -0.9901 0 153.7016)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3571F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2837,
    style: {
      stopColor: "#2767EF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5391,
    style: {
      stopColor: "#2062EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7827,
    style: {
      stopColor: "#195DEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#175CEE"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M485.6,16.7C224.9,37,19.7,252.9,19.7,516.2s205.2,479.2,465.8,499.4c260.7-20.3,465.8-236.1,465.8-499.4 S746.2,37,485.6,16.7z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_7_",
    cx: 485.558,
    cy: -366.0974,
    r: 443.0939,
    gradientTransform: "matrix(1 0 0 -0.9901 0 153.7016)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFCF8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9485,
    style: {
      stopColor: "#FFFCF8",
      stopOpacity: 0.05098
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFCF8",
      stopOpacity: 0
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M511.7,62.6c-17.4-2.3-35-2.3-52.4,0C233.8,93,59.9,284.5,59.9,516.2s173.9,423.2,399.5,453.6 c17.4,2.3,35,2.3,52.4,0c225.6-30.4,399.5-221.9,399.5-453.6S737.3,93,511.7,62.6z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_8_",
    cx: 559.8332,
    cy: -310.3859,
    r: 639.573,
    gradientTransform: "matrix(0.9201 0 0 -0.994 6.8952 155.5744)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1154E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3227,
    style: {
      stopColor: "#1154E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6649,
    style: {
      stopColor: "#1155E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1155E3"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M859.5,516.2c0-224.3-168.3-406.2-376-406.2c-207.7,0-376,181.9-376,406.2s168.3,406.2,376,406.2 C691.2,922.4,859.5,740.5,859.5,516.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 794.6771,
    y1: -603.1747,
    x2: 235.1682,
    y2: -129.0194,
    gradientTransform: "matrix(1 0 0 -0.9901 0 153.7016)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002257436,
    style: {
      stopColor: "#244DA3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4631,
    style: {
      stopColor: "#2365EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#628DF0"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M586.7,125.5c-46.8-14.4-96.8-14.4-143.6,0c-157.5,48.5-272.8,205-272.8,390.7 c0,189.3,119.9,348.3,282.1,393.4c40.8,11.3,84.2,11.3,125,0c162.2-45.1,282.1-204.1,282.1-393.4 C859.5,330.5,744.2,174,586.7,125.5z"
  })), /*#__PURE__*/React.createElement("g", null, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M647.1,275.3C566,277.4,501,349.4,501,432s64.5,153.5,146.2,156.7c81.1,0,146.2-74.1,146.2-156.7 S728.3,277.4,647.1,275.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_10_",
    cx: 705.6836,
    cy: -265.759,
    r: 150.3586,
    gradientTransform: "matrix(0.9201 0 0 -0.994 6.8952 155.5744)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1154E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1154E1"
    }
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M735.5,432c0-52.7-39.6-95.5-88.4-95.5c-48.8,0-88.4,42.8-88.4,95.5s39.6,95.5,88.4,95.5 C696,527.5,735.5,484.7,735.5,432z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_11_",
    cx: 996.9077,
    cy: -248.1187,
    r: 140.6558,
    fx: 1128.2635,
    fy: -298.4146,
    gradientTransform: "matrix(0.8799 0 0 -0.9901 -242.6215 153.7016)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#427AF1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFA700"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M677.1,342.4c-9.7-3.4-18.1-5.6-27.7-2.2C616.8,351.5,593,388.3,593,432c0,44.5,24.8,81.9,58.4,92.5 c8.5,2.7,18.9-1,27.4-3.7c27.7-12.5,56.8-44.3,56.8-88.8C735.5,388.3,709.7,353.8,677.1,342.4z"
  })))), /*#__PURE__*/React.createElement("g", null, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M536.4,641.1c-43.3,0-78.1,37.8-78.1,81.9s34.5,81.6,78.1,81.6c44-1.4,78.1-37.4,78.1-81.6 S579.7,642.5,536.4,641.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_12_",
    cx: 974.6296,
    cy: -755.0665,
    r: 54.5197,
    gradientTransform: "matrix(0.8612 0 0 -0.9304 -299.886 16.3755)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1155E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1155E3"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M566.4,723c0-17.9-13.4-32.4-30-32.4c-16.6,0-30,14.5-30,32.4c0,17.9,13.4,32.4,30,32.4 C553,755.5,566.4,740.9,566.4,723z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_13_",
    cx: 2617.7644,
    cy: -824.839,
    r: 50.9872,
    fx: 2665.3804,
    fy: -843.071,
    gradientTransform: "matrix(0.6672 0 0 -0.9046 -1207.8624 -33.8901)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#427AF1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFA700"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M548.2,693.3c-2.7-1.1-2.8-1.7-5.4-0.6c-9,3.8-15.5,16-15.5,30.4c0,14.7,6.8,27.1,16,30.6 c2.3,0.9,5.5-1.6,7.8-2.5c6.5-4,15.3-13.4,15.3-28.2C566.4,708.5,557.1,697.1,548.2,693.3z"
  })))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M422.3,383.6c-18,0-33.7,16-33.7,35.1c0,19.1,15,34.8,33.7,34.8c19.3,0,33.7-15.8,33.7-34.8 C456,399.6,440.5,383.6,422.3,383.6z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M309.7,636.1c-18,0-33.7,16-33.7,35.1s15,34.8,33.7,34.8c19.3,0,33.7-15.8,33.7-34.8S327.9,636.1,309.7,636.1z "
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M716.7,682.2c-18,0-33.7,16-33.7,35.1c0,19.1,15,34.8,33.7,34.8c19.3,0,33.7-15.8,33.7-34.8 C750.5,698.2,735,682.2,716.7,682.2z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_14_",
    d: "M586.7,125.3c-46.8-14.4-96.8-14.4-143.6,0c-157.5,48.5-272.8,205-272.8,390.7 c0,189.3,119.9,348.3,282.1,393.4c40.8,11.3,84.2,11.3,125,0C739.6,864.3,859.5,705.3,859.5,516 C859.5,330.3,744.2,173.8,586.7,125.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_15_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_14_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M299.2,195.4c-43.3,0-78.1,37.8-78.1,81.9s34.5,81.6,78.1,81.6c44-1.4,78.1-37.4,78.1-81.6 S342.5,196.8,299.2,195.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_16_",
    cx: 699.2153,
    cy: -276.0053,
    r: 54.5197,
    gradientTransform: "matrix(0.8612 0 0 -0.9304 -299.886 16.3755)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1155E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1155E3"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M329.2,277.3c0-17.9-13.4-32.4-30-32.4c-16.6,0-30,14.5-30,32.4c0,17.9,13.4,32.4,30,32.4 C315.8,309.7,329.2,295.2,329.2,277.3z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_17_",
    cx: 2262.2563,
    cy: -332.1213,
    r: 50.9872,
    fx: 2309.8723,
    fy: -350.3534,
    gradientTransform: "matrix(0.6672 0 0 -0.9046 -1207.8624 -33.8901)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#427AF1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFA700"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M311,247.6c-2.7-1.1-2.8-1.7-5.4-0.6c-9,3.8-15.5,16-15.5,30.4c0,14.7,6.8,27.1,16,30.6 c2.3,0.9,5.5-1.6,7.8-2.5c6.5-4,15.3-13.4,15.3-28.2C329.2,262.8,319.9,251.4,311,247.6z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoloToken);
export default __webpack_public_path__ + "static/media/yolo_token.44fa928bf288d71b57601af9024701f9.svg";
export { ForwardRef as ReactComponent };